<div>
  <form [formGroup]="dateForm">
    <label [for]="button?.button_id">{{ button?.button_label }}</label>
    <p *ngIf="button?.button_sublabel" class="text-muted">
      {{ button?.button_sublabel }}
    </p>
    <input
      [type]="'text'"
      class="form-control input-rounded input-focus-border rounded-form"
      [id]="button?.button_id"
      [placeholder]="
        button?.button_placeholder
          ? button?.button_placeholder
          : 'Enter ' + button?.button_label
      "
      name="dp"
      bsDatepicker
      [bsConfig]="{
        isAnimated: true,
        adaptivePosition: true,
        showWeekNumbers: false,
        dateInputFormat: button.button_picker.format.toUpperCase(),
        container: 'body'
      }"
      formControlName="value"
      [ngClass]="{ 'is-invalid': f.value.errors }"
    />
    <div *ngIf="f.value.errors" class="invalid-feedback">
      <div *ngIf="f.value.errors.required">
        {{ errorMsgList["required"] }}
      </div>
      <div *ngIf="f.value.errors.minlength">
        {{ errorMsgList["minlength"] }}
      </div>
      <div *ngIf="f.value.errors.maxlength">
        {{ errorMsgList["maxlength"] }}
      </div>
      <div *ngIf="f.value.errors.pattern">
        {{ errorMsgList["pattern"] }}
      </div>
    </div>
  </form>
</div>
